import { Label, Text } from '@fluentui/react';
import { TextField } from '@fluentui/react/lib/TextField';
import { textProp } from 'global/Application';
import Formatters from 'global/Utility/Formatters';
import { INumberValue, IStringValue } from 'model/FlexibleAttributeModel';
import React, { useState } from 'react';

interface IProps {
    [key: string]: any;
    fieldValueOnChange?: (event: any, value: INumberValue | null) => void;
    defaultFieldValue?: IStringValue;
}

const Currency: React.FC<IProps> = (props) => {
    const { label, handleChange, defaultValue, disabled, ...other } = props;

    const [displayValue, setDisplayValue] = useState(props.defaultFieldValue
        ? Formatters.ToCurrencyUSD(Number(props.defaultFieldValue.value))
        : ''
    );

    //TODO useMemo, in case of rerender(controlled component) this debounce will be gone!
    // debounce an input so we dont fire onchange for every input, only fire the last one after x msec.
    // const fieldValueOnChange = _.debounce(
    //     (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
    //         const value: IStringValue = {
    //             type: 'string',
    //             value: newValue!
    //         }
    //         props.fieldValueOnChange?.(event, value);
    //     }, 300);

    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{displayValue ? displayValue : '$--.--'}</Text>
        </div>;

    return (
        <TextField
            placeholder='$--.--'
            label={label}
            disabled={disabled}
            // defaultValue={props.defaultFieldValue ? props.defaultFieldValue.value : defaultValue}
            value={displayValue}
            // onChange={props.fieldValueOnChange ? fieldValueOnChange : handleChange}
            onChange={(event, value) => {
                setDisplayValue(value ?? '');
            }}
            validateOnFocusOut={true}

            onGetErrorMessage={(value) => {
                return ''
            }}
            onBlur={(event) => {
                let value = displayValue.replace(/[^0-9.-]+/g, "");
                let valueNumber = Number(value);

                let valid = true;

                if (value === '')
                    valid = false;

                if (isNaN(valueNumber))
                    valid = false;

                // default currency is stored as Decimal(18,2)
                if (valueNumber > 9999999999999998)
                    valid = false;

                // default currency is stored as Decimal(18,2)
                if (valueNumber < -9999999999999998)
                    valid = false;

                const fieldValue: INumberValue | null = valid
                    ? {
                        type: 'number',
                        value: Number(valueNumber.toFixed(2))
                    }
                    : null;

                props.fieldValueOnChange?.(event, fieldValue);

                let display = valid ? Formatters.ToCurrencyUSD(valueNumber) : '';
                setDisplayValue(display);
            }}
            {...other}
        />
    )
}

export default Currency